import { environment } from '../../environments/environment';
const baseUrl = `${environment.apiBaseUrl}api/`;
const baseUrl2 = `${environment.apiBaseUrl}api/`;
const officebaseUrl = `${environment.apiBaseUrl}`;

export const APIs = {
  // getAuthToken: `${baseUrl}Home/oAuth/token`,
  // getMeetingRoomList:`${baseUrl}Home/resources`,
  // getCredits:`${baseUrl}credit-accounts/stats`
  postMeeting: `${baseUrl}Meeting/BookMeeting`,
  getDatabaseCredits: `${baseUrl}Credit/GetCredit`,
  getAllCredits: `${baseUrl}Credit/GetAllCredit`,
  
  getMeetingDetail: `${baseUrl}Meeting/GetMeetingDetail`,
  cancelMeeting: `${baseUrl}Meeting/CancelMeeting`,
  saveMeetingInvitees: `${baseUrl}MeetingInvitees/SaveMeetingInvitees`,
  saveMeetingInvitees2: `${baseUrl}MeetingInvitees/SaveMeetingInvitees2`,
  saveExternalMeetingInvitees: `${baseUrl}MeetingInvitees/SaveExternalMeetingInvitee`,
  removeMemberFromMeeting: `${baseUrl}MeetingInvitees/RemoveMeetingInvitee`,
  getMeetingRoomDetail: `${baseUrl}MeetingRoom/GetMeetingRoomDetail`,
  getMeetingInviteesList: `${baseUrl}MeetingInvitees/GetMeetingInviteesList`,
  getmeetingInviteesWithExternals: `${baseUrl}MeetingInvitees/meetingInvitees`,
  getApiAuthToken: `${baseUrl}token`,
  getAuthToken: `${baseUrl}OfficeRnd/oAuth/token`,
  getOfficeMembers: `${baseUrl}OfficeRnd/members`,
  getOfficeAccessPoints: `${baseUrl}OfficeRnd/resources`,
  getMeetingRoomOfficerndList: `${baseUrl}Home/resources`,
  getMeetingRoomList: `${baseUrl}Meeting/GetMeetingList`,
  getMeetingRoomListDetails: `${baseUrl}MeetingRoom/GetMeetingRoomList`,
  getTimelineData: `${baseUrl}Meeting/GetTimeLineData`,
  getCredits: `${baseUrl}credit-accounts/stats`,
  getDepartmentList: `${baseUrl}Employees/departmentList`,
  getAccessPoint: `${baseUrl}Employees/getAccessPoints`,
  addemployee: `${baseUrl}Employees/addEmployee`,
  getEmployeeList: `${baseUrl}Employees/GetEmployeeList`,
  updateUserAccessPoint: `${baseUrl}Employees/updateAccessPoint`,
  getUserInfo: `${baseUrl}Employees/getUserInfo`,
  getUserDepartmentInfo: `${baseUrl}Employees/getUserDepartmentInfo`,
  resendEmail: `${baseUrl}Employees/resendEmail`,
  getUserAccessPoints: `${baseUrl}Employees/getUserAccessPoints`,
  revokeAccess: `${baseUrl}Company/RemoveOrgEmployee`,
  addorupdateuserRole: `${baseUrl}Company/addorupdateUserRole`,
  addorupdateTenant: `${baseUrl}Company/addorupdateTenant`,
  addorupdateOrgEmployee: `${baseUrl}Company/addorupdateOrgEmployee`,
  gettenantbyUserId: `${baseUrl}Company/GetTenantbyUserId`,
  gettennatEmployeeList: `${baseUrl}Employees/GetTenantEmployeeList`,
  getEmailid: `${baseUrl}Employee/GetEmployeeList`,
  getUserDetail: `${baseUrl}Users`,
  getAdminDetails: `${baseUrl}Token/CheckAdmin`,
  getReportMeetingRooms: `${baseUrl}report/meetingrooms`,
  getAccessPoints: `${baseUrl}report/accesspoints`,
  getCheckins: `${baseUrl}report/checkins`,
  getCreditReports: `${baseUrl}report/creditreports`,
  getDepartments: `${baseUrl}report/departments`,
  getEmployees: `${baseUrl}report/employees`,
  getMeetings: `${baseUrl}report/meetings`,
  getContactsData: `${baseUrl}Contact`,
  getCoAdmins: `${baseUrl}Employees/getcoadmin`,
  getAdminData: `${baseUrl}Employees/getadmin`,
  removeUser: `${baseUrl}users/RemoveUser`,
  getTenantCredit: `${baseUrl}Credit/GetCredit`,
  updateUserCreditAccess: `${baseUrl}Users/ChangeCreditAccess`,
  changeCreditAccess: `${baseUrl}Users/ChangeCreditAccess`,
  disbursePoint: `${baseUrl}Credit/DisburseCreditPoints`,
  getTenantUser: `${baseUrl}Credit/GetMonthlyCreditSpentByTenantId`,
  getOverviewTenant: `${baseUrl}OverView/GetOverviewTenant`,
  getTenantOtherDetails: `${baseUrl}Company/GetTenantOtherDetails`,
  forgotPasswordPortal: `${baseUrl}Users/ForgetPasswordPortal`,
  user: `${baseUrl}Users`,
  removeCoAdmin: `${baseUrl}Employees/remove`,
  saveCoAdmin: `${baseUrl}Employees/SaveAdmin`,
  updateCoAdmin: `${baseUrl}Employees/UpdateAdmin`,
  getTenantSavedAccessPoints: `${baseUrl}Employees/getTenantSavedAccessPoints`,
  getadmindetails: `${baseUrl}Employees/getadmindetails`,
  getParkiteAdmin: `${baseUrl}pms/Employees/GetParkiteAdminDetails`,
  changeActivation: `${baseUrl}Employees/UpdateTenantMemberStatus`,
  getBulkEmployeesUploadTemplate: `${baseUrl}Employees/GetBulkEmployeesUploadTemplate`,
  bulkEmployeesUpload: `${baseUrl}Employees/BulkUpload`,
  isTenantAdminExists: `${baseUrl}Token/IsTenantAdminExists`,
  // updatePassword: `${baseUrl}Users/UpdatePasswordPortal`,
  sendEmailsToMember: `${baseUrl}Employees/SendMembersOnboardingEmail`,
  getAllNotifications: `${baseUrl}PushNotification/GetPortalNotificationDetails`,
  clearNotification: `${baseUrl}PushNotification/ClearPortalNotification`,
  updateNotification: `${baseUrl}PushNotification/UpdateNotification`,
  updateMemberAccessPoint: `${baseUrl}Employees/UpdateUserAccessPoint`,
  RequestCreditPoints: `${baseUrl}Credit/SendRequestCreditPointsmail`,
  logoutToken: `${baseUrl}Token/Logout`,
  resetPassword: `${baseUrl}users/UpdatePasswordPortalNew`,
  updatePassword: `${baseUrl}users/ChangePasswordPortal`,
  revokeEmployeeRights: `${baseUrl2}pms/Employees/RevokeAccess`,
  saveEmployees: `${baseUrl2}pms/Employees/SaveEmployee`,
  getBuildingByParkId: `${baseUrl2}pms/Company/GetBuildingListByPark`,
  getBuildingByParkIdAndTenatID: `${baseUrl}pms/Park/GetParkBuildings`,
  getEmployeeDetailsByTenantId: `${baseUrl}pms/Employees/CurrentUserDetails`,
  employeeListByFilter: `${baseUrl2}pms/Employees/EmployeeDetailsWithFilter`,
  employeeVmsInvitationRights: `${baseUrl2}VMS/VMS/VMSAccess`,
  saveEmployeeStatus: `${baseUrl2}pms/Employees/SaveEmployeeStatus`,
  // getMyCompanyDetails: `${baseUrl2}pms/Employees/GetMyCompanyDetails`,

  getOverviewTA: `${baseUrl2}pms/OverView/GetOverViewDetails`,
  //Phase2 Apis - PMS
  getMyCompanyDetails: `${baseUrl2}pms/Employees/GetMyCompanyDetails`,
  getBulkParkEmployeesUploadTemplate: `${baseUrl}pms/BulkUpload/GetBulkEmployeesUploadTemplate`,
  bulkParkEmployeesUpload: `${baseUrl}pms/BulkUpload/BulkUpload`,
  saveBulkParkUsersDetails: `${baseUrl}pms/BulkUpload/SaveBulkParkUsersDetails`,
  deleteParkUserDetail: `${baseUrl}pms/BulkUpload/DeleteParkUserDetail`,
  deleteBaseUsersDetail: `${baseUrl}pms/BulkUpload/DeleteBaseUsersDetail`,
  sendEmailsToParkUsers: `${baseUrl}pms/BulkUpload/SendWelcomeMembersMessage`,
  verifyEmail: `${baseUrl}pms/Employees/VerifyEmail`,
  reBulkUpload: `${baseUrl}pms/BulkUpload/ReBulkUpload`,


  // phse 2 VMS
  getVmsHostDetail: `${baseUrl2}VMS/VMSGuest/GetHostDetails`,
  getVmsVehicleType: `${baseUrl2}VMS/VMSMasterData/GetVehicleType`,
  createVmsInvitation: `${baseUrl2}VMS/VMS/CreateInvitation`,
  getVmsMeetingPurpose: `${baseUrl2}VMS/VMSMasterData/GetMeetingPurpose`,
  getInvitationDetail: `${baseUrl2}VMS/VMS/GetInvitationDetails`,
  resendInvitation: `${baseUrl2}VMS/VMS/ResendInvitation`,
  cancelInvitation: `${baseUrl2}VMS/VMS/CancelInvitation`,
  getVmsInvitationList: `${baseUrl2}VMS/VMS/GetInvitationListForLandingPage`,
  getBulkInviteTemplate: `${baseUrl2}VMS/VMSGuest/GetBulkInviteExcelTemplate`,
  getInvitationType: `${baseUrl2}VMS/VMSMasterData/GetInvitationType`,
  deleteVmsGuest:`${baseUrl2}VMS/VMSGuest/DeleteGuest`,
  //reports
  getFireWardenReportData:`${baseUrl}FireWarden/FireWarden/FireWardenReportTA`,
  getInviteCompanyList:`${baseUrl}VMS/VMSTab/GetCompanyListByPark`,
  getHistoryDetails:`${baseUrl}VMS/VMS/GetVMSInvitationHistory`,
  approvalRemainder:`${baseUrl}VMS/VMS/BulkInvitationApprovalReminder`,
  getVMSReportData:`${baseUrl}VMS/VMSReport/VMSTAReport`,
  getEventsCategoryData:`${baseUrl}Events/GetEventsCategory`,
  getEventsReportData:`${baseUrl}Events/GetEventsReportForTA`,


};

export const LoaderExcludes = [
  'GetNotificationDetails',
  'ClearNotification',
  'UpdateNotification',
  'GetPortalNotificationDetails',
  'Contact',
];
